import apolloClient from "../connection/apolloClient";
import ROUTE_LOGIN from "../mutations/route_login";

const executeRouteLogin = async (email, origin, data = "") => {
  let result;
  const variables = { data, email, origin };

  try {
    result = await apolloClient.mutate({ mutation: ROUTE_LOGIN, variables });
  } catch (e) {
    throw new Error(e);
  }

  return result;
};

export default executeRouteLogin;
